import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getRefGenomeName } from "../../components/3d-protein-viewer/selectors/ProteinViewer.selectors";
import goToLinkInternally from "./goToLinkInternally";
import { getShouldRenderLinksToVarsome } from "../../state/selectors/general.selectors";

const insertRefGenomeToGeneLink = (url, refgenome) => {
  if (!refgenome) return url;
  const splitted = url.split("/");
  splitted.splice(4, 0, refgenome);
  return splitted.join("/");
};

function GeneWithRefGenomeLink({
  href,
  refgenome,
  children,
  target,
  className,
  onClick,
  style,
  rel,
  onMouseDown,
  key,
  goInternally,
  shouldRenderLinksToVarsome,
}) {
  if (!href) return null;
  if (!shouldRenderLinksToVarsome) return children;
  return (
    <a
      href={insertRefGenomeToGeneLink(href, refgenome)}
      target={goInternally ? "" : target}
      className={className}
      onClick={
        goInternally
          ? (e) =>
              goToLinkInternally(
                insertRefGenomeToGeneLink(
                  insertRefGenomeToGeneLink(href, refgenome)
                ),
                e
              )
          : onClick
      }
      style={style}
      rel={rel}
      onMouseDown={onMouseDown}
      key={key}
    >
      {children}
    </a>
  );
}

const mapStateToProps = (state) => ({
  refgenome: getRefGenomeName(state),
  shouldRenderLinksToVarsome: getShouldRenderLinksToVarsome(),
});

GeneWithRefGenomeLink.propTypes = {
  href: PropTypes.string.isRequired,
  refgenome: PropTypes.string,
  children: PropTypes.node,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.shape({}),
  rel: PropTypes.string,
  onMouseDown: PropTypes.func,
  key: PropTypes.string,
  goInternally: PropTypes.bool,
  shouldRenderLinksToVarsome: PropTypes.bool.isRequired,
};

GeneWithRefGenomeLink.defaultProps = {
  refgenome: "",
  children: [],
  target: "_blank",
  className: "",
  onClick: () => {},
  style: null,
  rel: "",
  onMouseDown: () => {},
  key: "",
  goInternally: false,
};

export default connect(mapStateToProps)(GeneWithRefGenomeLink);
